<template>
  <b-navbar
    type="light"
    toggleable="xl"
    fixed="top"
    v-b-scrollspy:nav-scroller
    class="header-area"
    :class="{'is-sticky': scrolled}"
  >
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand">
        <router-link :to="{name:'HomeBranding'}">
        
          <img src='../assets/img/logo/logo-dark.png' alt="logo-karpin" loading="lazy"/>
          <!-- <p style="width:180px;color:Red">
          <marquee-text  :duration="30" :repeat="3">
          Yazılım , 
          Software , 
          البرمجيات, 
          Программного , 
          软件 , 
          </marquee-text>
          
          </p> -->
          
        </router-link>
      </b-navbar-brand>
      <b-btn-group class="header-config-wrapper">
        
        <feather-icon  @click="toggleClass('addClass', 'active')" class="fal fa-search cursor-pointer navbar-fuzzy-search ml-4 md:flex" />
        <cart-drop-down />
        <!-- <router-link to="/checkout"><b-btn class="header-config">
          <i class="fa fa-shopping-cart"></i>
        </b-btn>
        </router-link> -->
        <!-- <b-link class="ht-btn ht-btn--outline hire-btn d-none d-xl-block">Hire Us Now</b-link> -->
      </b-btn-group>
      <b-collapse class="default-nav justify-content-center" is-nav id="nav_collapse">
        <b-navbar-nav class="navbar-nav main-menu" >
          <!-- <b-nav-item to="/"><span>LANDING</span></b-nav-item> -->
          <!-- <b-nav-item href="#home" class="scroll"><span>HOME</span></b-nav-item> -->
          <b-nav-item to="/about">
            <span>{{ $t('about') }}</span>
          </b-nav-item>
          <b-nav-item to="/services">
            <span>{{ $t('services') }}</span>
          </b-nav-item>
          <b-nav-item to="/efatura">
            <span>{{ $t('efatura') }}</span>
          </b-nav-item>
          <!-- <b-nav-item target="_blank" class="blink"  href="http://mobil.barkodyazilimevi.com.tr">
            <span style="color:red">{{ $t('demo') }}</span>
          </b-nav-item> -->
          <b-nav-item to="/references">
            <span>{{ $t('references') }}</span>
          </b-nav-item>
          <b-nav-item to="/download">
            <span>{{ $t('support') }}</span>
          </b-nav-item>
          <!-- <b-nav-item href="https://www.barkodyazilimevi.com.tr/shop"> -->
          <b-nav-item to="/shop">
            <span>{{ $t('shop') }}</span>
          </b-nav-item> 
          <b-nav-item to="/contacts">
            <span>{{ $t('contacts') }}</span>
          </b-nav-item>
          <language />
          <!-- <b-nav-item-dropdown :text="$i18n.locale" right>
            <b-dropdown-item
              v-for="que in locales"
              :key="que.Value"
              @click="updateLocale(que.Value)"
            >
              <img
                class="h-4 w-5 mr-1"
                style="height:16px;width:16px"
                :src="require(`@/assets/img/flags/1x1/${que.Value}.svg`)"
                :alt="que.Value"
              />
              &nbsp;{{que.Name}}
            </b-dropdown-item>
          </b-nav-item-dropdown> -->
          <!-- <b-nav-item><DxDropDownButton
                    :data-source="locales"
                    :items="locales"
                    valueExpr="Value"
                    display-expr="Name"
                    key-expr="Value"
                    :text="locale"
                    :use-select-mode="true"
                    :show-arrow-icon="false"
                    :selectedItemKey="locale"
                    :selectedItem="locale"
                    stylingMode="text"
                    style="width:100px"
                    :active-state-enabled="true"
                    >
                    </DxDropDownButton>
          </b-nav-item>-->
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import { DxDropDownButton } from "devextreme-vue";
import CartDropDown         from '../layouts/components/navbar/components/CartDropDown.vue'
import language                 from '../layouts/components/navbar/components/I18n.vue'
import i18n from "../i18n/i18n";
import service from "../data.js";
import MarqueeText from 'vue-marquee-text-component'

export default {
  name: "HeaderSoftware",
  props: {
    msg: String
  },
  components: {
    DxDropDownButton,CartDropDown,language,MarqueeText
  },
  data() {
    return {
      locale: "tr",
      flag: "../assets/img/flags/1x1/tr.svg",
      locales: service.getLocales(),
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500
    };
  },
  // I18N
  getCurrentLocaleData() {
    const locale = this.$i18n.locale;
    if (locale == "en") return { flag: "us", lang: "English" };
    else if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
    else if (locale == "ar") return { flag: "ar", lang: "العربية" };
  },
  mounted() {
    (function() {
      scrollTo();
    })();

    function scrollTo() {
      const links = document.querySelectorAll(".scroll > a");
      links.forEach(each => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, respond = null) {
      const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
      e.preventDefault();
      var targetID = respond
        ? respond.getAttribute("href")
        : this.getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });
      const checkIfDone = setInterval(function() {
        const atBottom =
          window.innerHeight + window.pageYOffset >=
          document.body.offsetHeight - 190;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = "-1";
          targetAnchor.focus();
          clearInterval(checkIfDone);
        }
      }, 800);
    }
  },
  methods: {
    updateLocale(locale) {
      this.locale = locale;
      i18n.locale = locale;
      this.setLocale(locale);
    },
    getLocale() {
      const locale = sessionStorage.getItem("locale");
      return locale != null ? locale : "tr";
    },
    setLocale(locale) {
      console.log(locale);
      sessionStorage.setItem("locale", locale);
    },
    initGlobalize() {},
    changeLocale(e) {
      this.i18n.locale = e.value;
      console.log(e.value);
      //this.setLocale(e.value);
      //document.location.reload();
    },
    //formatMessage: Globalize.formatMessage.bind(Globalize),
    // sticky menu script
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },

    // offcanvas searchbox
    toggleClass(addRemoveClass, className) {
      const el = document.querySelector("#search-overlay");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  created() {
    this.locale = this.getLocale();
    //this.i18n.locale = this.locale;
    //console.log(this.locale);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
.blink {
      animation: blinker 0.9s linear infinite;
      /*color: #1c87c9; */
      color: #009688;
      font-size: 30px;
      font-weight: bold;
      /* font-family: sans-serif; */
      }
      @keyframes blinker {  
      50% { opacity: 0; }
      }
</style>
